import React from "react";
import Head from "next/head";
import { useRouter } from "next/router";
// @material-ui/core components
import { makeStyles } from "tss-react/mui";

// @material-ui/icons
// core components
import Header from "../components/Header/Header.js";
import Footer from "../components/Footer/Footer.js";
import HeaderLinks from "../components/Header/HeaderLinks.js";
import logo from "../public/img/logo.png";

import styles from "../styles/jss/nextjs-material-kit/pages/contactStyle.js";
import PreFooter from "../pages-sections/LandingPage-Sections/PreFooter.js";
import { client } from "../request/client";
import useSWR from "swr";
import JSONSchemaData from "../components/JSONSchemaData/JSONSchemaData";
import Grid from "@mui/material/Grid";
import ContactForm from "../components/ContactForm";
import PageDetails from "../pages-sections/PageDetails";

const dashboardRoutes = [];

const useStyles = makeStyles()(styles);

export default function ArticleDetailPage(props) {
  const { classes, cx } = useStyles();
  const { ...rest } = props;
  const router = useRouter();
  const { slug } = router.query;

  const { data: page, error, isLoading } = useSWR(`/v1/page/${slug}`, null, {
    fallbackData: props.fallback,
  });


  const jsonBreadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [{
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://successatschool.org/"
    }, {
      "@type": "ListItem",
      "position": 2,
      "name": page.title,
      "item": `https://successatschool.org/page/${page.pageKey}`
    }]};

  return (
    <div>
      <Head>
        <title>
          {page?.title}
        </title>
        <meta
          name="description"
          content={page?.meta_description}
          key="desc"
        />
        <meta
          name="keywords"
          content={page?.meta_keywords}
          key="keywords"
        />
        {!!page && <>
          <link rel="canonical" href={`https://successatschool.org/page/${page.pageKey}`} />
        </>}
      </Head>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        logo={logo}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white",
        }}
        {...rest}
      />
      <div className={cx(classes.bg_colored)}>
        <div className={cx(classes.container)}>
          {(isLoading)
            ? <strong>Loading...</strong>
            : <PageDetails page={page} />
          }
          
          <Grid container rowSpacing={4} className={cx(classes.containerFullHeight, classes.contactForm)}>
            <Grid item xs={12}>
              <div className={cx(classes.block)}>
                <Grid container className={cx(classes.blockTitle)}>
                  <Grid item>
                    <h2>Contact form</h2>
                  </Grid>
                  <Grid item>
                    
                  </Grid>
                </Grid>
                <div className={cx(classes.blockMain)}>
                  <ContactForm />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

        <div className={cx(classes.darkBlue, "footer", "colored_bgg")}>
          <PreFooter />
        </div>
        <Footer />
        <JSONSchemaData key_name={'breadcrumbSchema'} data={jsonBreadcrumbData} />
      </div>
    </div>
  );
}

export async function getServerSideProps({ query }) {
  try {
    const data = await client({
      url: `/v1/page/contactus`,
      method: "get",
      headers: {},
    }).then((res) => res.data);

    return {
      props: {
        fallback: data,
      }
    };
  }
  catch (e) {
    if (e.response && e.response.status === 404) {
      return {
        notFound: true,
      };
    }
    else {
      throw e;
    }
  }
}

